import { render } from "./QuizStep1.vue?vue&type=template&id=6eb24ec3"
import script from "./QuizStep1.vue?vue&type=script&lang=js"
export * from "./QuizStep1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__